export default __webpack_public_path__ + "static/whyUs-4a4304c6e18d367fabb1f16d2c99056f.webp";